/**
 * Configuração centralizada das badges "Novo" nos itens de menu.
 *
 * Para adicionar/remover/ajustar uma badge:
 *  - `menuId`    → ID do item de menu em useMenu.tsx
 *  - `startDate` → Data em que a funcionalidade foi publicada (YYYY-MM-DD)
 *  - `durationDays` → Quantos dias a badge fica visível (padrão: 14)
 *
 * A badge some automaticamente quando hoje > startDate + durationDays.
 */
export type FeatureBadgeConfig = {
  menuId: string;
  startDate: string;
  durationDays?: number;
};

export const FEATURE_BADGES: FeatureBadgeConfig[] = [
  {
    menuId: "packages",
    startDate: "2026-04-29",
    durationDays: 14,
  },
];
